module.exports = __webpack_public_path__ + "static/avatar-4ac08b1862ef25103b649b39aecc782c.jpg";